import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../pages/home.vue';
import SecretSanta from '../pages/secret-santa.vue';
import Account from '../pages/account.vue';
import Admin from '../pages/admin.vue';
import Login from '../pages/login.vue';
import SideNav from '../components/side-nav.vue';

import { auth } from './auth.js';

const routerHistory = createWebHistory();

const router = createRouter({
    history: routerHistory,
    routes: [{
            path: '/',
            components: {
                default: SecretSanta,
                SideNav,
            },
            // component: SecretSanta,
        },
        {
            path: '/secret-santa',
            components: {
                default: SecretSanta,
                SideNav,
            },
        },
        {
            path: '/account',
            // component: Account,
            components: {
                default: Account,
                SideNav,
            },
        },
        {
            path: '/admin',
            // component: Admin,
            components: {
                default: Admin,
                SideNav,
            },
        },
        {
            path: '/login',
            component: Login,
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    if (to.path !== '/login' && !(await auth.isLoggedIn())) {
        console.log('redirecting to login');
        next({ path: '/login' });
    } else if (to.path === '/admin' && !auth.session.isAdmin)
        next({ path: '/' });
    else next();
});

export default router;
